import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useMemo } from 'react';
import { AppRow } from '../../layout/appRow';
import { AutocompleteOption } from '../../models/autocompleteOption';
import { AppToolbox } from '../app/appToolbox';
import { AppButtonContained } from '../app/button/appButtonContained';
import { AppButtonOutlined } from '../app/button/appButtonOutlined';
import { AppAutocomplete } from '../app/input/appAutocomplete';

interface Props {
  countries: AutocompleteOption[];
  selectedCountry: AutocompleteOption;
  yearOptions: AutocompleteOption[];
  selectedYear: AutocompleteOption;
  isAdmin: boolean;
  handleChangeCountry: (e: React.BaseSyntheticEvent) => void;
  handleChangeYear: (e: React.BaseSyntheticEvent) => void;
  handleGenerateHolidays: () => void;
  onAdd: () => void;
}

const makeStyles = (isMobile: boolean) => ({
  container: { mb: 1, p: 1 },
  dropdownBox: { display: 'flex', flexWrap: 'wrap' },
  yearAutocomplete: { width: 150, mr: 2, mb: isMobile ? 2 : 0 },
  countryAutocomplete: { width: 220 },
  generateHolidaysBtn: { mr: 2 },
});

export function HolidaysToolbox({
  countries,
  selectedCountry,
  yearOptions,
  selectedYear,
  handleChangeCountry,
  handleChangeYear,
  handleGenerateHolidays,
  onAdd,
  isAdmin,
}: Props): JSX.Element {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const styles = makeStyles(isMobile);

  const defaultYear = useMemo(() => {
    return selectedYear;
  }, []);

  const defaultCountry = useMemo(() => {
    return selectedCountry;
  }, []);

  return (
    <AppToolbox
      pageTitle="Holidays"
      secondChildren={
        <>
          {isAdmin && (
            <AppRow>
              <AppButtonOutlined
                handleClick={handleGenerateHolidays}
                sx={styles.generateHolidaysBtn}
                label="Generate holidays"
              />

              <AppButtonContained
                label="Add"
                isIconButton
                handleClick={onAdd}
              />
            </AppRow>
          )}
        </>
      }
      thirdChildren={
        <Box sx={styles.container}>
          <Box sx={styles.dropdownBox}>
            <AppAutocomplete
              label="Year"
              name="year"
              options={yearOptions}
              defaultValue={defaultYear}
              sx={styles.yearAutocomplete}
              handleChange={handleChangeYear}
            />

            <AppAutocomplete
              label="Country"
              name="country"
              options={countries}
              defaultValue={defaultCountry}
              sx={styles.countryAutocomplete}
              handleChange={handleChangeCountry}
            />
          </Box>
        </Box>
      }
    />
  );
}
